import { type UseQueryResult, useQuery } from 'react-query';
import { StatusDropdownAppServicesService } from '@wealthlane/api-services/wealthlane-award-service';

const useGetVestingLoadingType = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const loadingType = useQuery(
    ['getVestingLoadingType'],
    async () => {
      return await handleRequest(
        StatusDropdownAppServicesService?.getApiAwardApiAppStatusDropdownAppServicesLoadingTypes()
      );
    },
    {
      select: (data) => {
        // Define the order array
        const orderArray = ['first', 'last', 'front', 'back', 'null'];

        // Sort the data based on the orderArray
        const sortedData = [...(data ?? [])].sort((a, b) => {
          const aSystem = a.systemName?.toLowerCase() ?? 'null';
          const bSystem = b.systemName?.toLowerCase() ?? 'null';

          return orderArray.indexOf(aSystem) - orderArray.indexOf(bSystem);
        });

        return sortedData?.map((item) => {
          return {
            label: `${item.displayName}`,
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return loadingType;
};

export default useGetVestingLoadingType;
